;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"b5501048efa89f0aed70a85b96202c33b1b3c4c4"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { SHARED_SENTRY_CONFIG } from './sentry.shared.config';

Sentry.init({
  ...SHARED_SENTRY_CONFIG,
});
